import React from "react";
import Reveal from "./Reveal";

const reviews = [
  {
    quote:
      "O Miguel apanhou o momento exato em que cruzei a meta. Nunca tinha visto uma foto assim — parece um filme. Foi ele que tornou a minha primeira vitória inesquecível.",
    name: "Ana Mendes",
    role: "Ciclista — Equipa Norte",
  },
  {
    quote:
      "Profissional, rápido e com olho cirúrgico. As fotos da prova foram entregues no dia seguinte, prontas para imprensa. Voltámos a contratar três vezes.",
    name: "Rui Carvalho",
    role: "Organizador — Trail Serra Estrela",
  },
  {
    quote:
      "Pedi um retrato e saí com uma obra. Preto, branco, e algo de mim que nem eu conhecia. Recomendo a qualquer atleta.",
    name: "Inês Tavares",
    role: "Atleta de Off-Road",
  },
];

const Quote = () => (
  <svg
    className="absolute top-6 right-6 text-[#c0392b]"
    width="42"
    height="32"
    viewBox="0 0 42 32"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 0C5.4 0 0 5.4 0 12v20h16V16H8c0-4.4 3.6-8 8-8V0h-4zm26 0c-6.6 0-12 5.4-12 12v20h16V16h-8c0-4.4 3.6-8 8-8V0h-4z" />
  </svg>
);

const Testimonials = () => {
  return (
    <section
      id="depoimentos"
      className="bg-black py-24 md:py-32 border-t border-white/10"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <div className="mb-14">
            <div className="flex items-center gap-3 mb-4">
              <span className="divider-red" />
              <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">06 — Depoimentos</span>
            </div>
            <h2 className="font-heading text-white text-6xl md:text-8xl uppercase leading-[0.9]" data-testid="testimonials-title">
              Em<br />Movimento
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={i * 120}>
              <div className="testimonial-card border-t border-r border-b border-white/15 h-full" data-testid={`testimonial-${i}`}>
                <Quote />
                <p className="text-white/90 text-base md:text-lg leading-relaxed font-light italic mb-10">
                  {r.quote}
                </p>
                <div className="pt-5 border-t border-white/15">
                  <div className="font-heading text-white tracking-[0.15em] uppercase">{r.name}</div>
                  <div className="text-white/55 text-xs tracking-[0.2em] uppercase font-heading mt-1">{r.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
